// extracted by mini-css-extract-plugin
export default {"modal_container":"Modal_modal_container__lg4pe","overlay":"Modal_overlay__ourQx"};